import { PollDetailPage } from '@/components/governance/poll-detail-page'

export function AdminPollDetail() {
  return <PollDetailPage basePath="/admin/polls" />
}
